// mimics the api of the react-native Alert component
// pass the negative or cancel option as the first button, confirm option as the second button
// if only one button is passed in its onPress will be called on both confirm and on reject

export default {
  alert: function(title, description, buttons) {
    const displayText = `${title}: ${description}`;
    if (!buttons?.length) {
      alert(displayText);
      return;
    }

    // button at 0 index is the negative option
    // button at 1 is confirm option
    // if only 1 button is passed in it'll be called no matter what the user chooses
    let actionConfirm = buttons.length === 1 ? buttons[0]?.onPress : buttons[1]?.onPress;
    let actionReject = buttons[0]?.onPress;

    if (confirm(displayText)) {
      actionConfirm && actionConfirm();
    } else {
      actionReject && actionReject();
    }
  },
};
